import { Modal } from "react-bootstrap";
import { OrderModel, OrderProductModel } from "../../../models";
import { useState } from "react";
import { formatPhoneNumber, toAbsoluteUrl } from "../../../helpers";
import { useAuth, useStore, useCart } from "../../../hooks";
import { formatCurrency, formatDate } from "../../../utilities";
import { GetReorderData } from "../../../services";
import { useNavigate } from "react-router-dom";
import FavOrderModal from "./FavOrderModal";
import { HeartFill } from "react-bootstrap-icons";
import clsx from "clsx";
import { OrderProduct } from "../..";
import {
  FiClock,
  FiFileText,
  FiMapPin,
  FiPackage,
  FiPhone,
} from "react-icons/fi";
import { DoorDashIcon } from "../../../icons";
import { Toast } from "../../Toast";

type Props = {
  order: OrderModel;
  show: boolean;
  handleClose: () => void;
  handleFavOrder: () => void;
};

const OrderDetailModal: React.FC<Props> = ({
  order,
  show,
  handleClose,
  handleFavOrder,
}) => {
  let navigate = useNavigate();
  const { storeId, selectedStore } = useStore();
  const { customerId } = useAuth();
  const { setCartItems } = useCart();

  const [showFavModal, setShowFavModal] = useState<boolean>(false);

  const handleReorder = async () => {
    try {
      const { status, message, data } = await GetReorderData({
        store_id: storeId,
        order_id: order.order_id,
        customer_id: customerId,
      });
      if (status) {
        setCartItems(data.cartdata);
        Toast.info("Items added to cart");
        navigate("/");
      } else Toast.error(message);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <Modal
        className="order_option_popup order-detail-modal"
        show={show}
        onHide={handleClose}
        fullscreen="sm-down"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Order Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="thank_sec">
            <ul className="row">
              <li className="col-12 col-md-6">
                <div className="order-detail-box">
                  <FiFileText className="detail-icon" />
                  <h5>
                    Order Number
                    <span># {order?.order_id}</span>
                  </h5>
                </div>
              </li>
              <li className="col-12 col-md-6">
                <div className="order-detail-box">
                  <FiClock className="detail-icon" />
                  <h5>
                    Order Time
                    <span>
                      {order?.create_ts ? formatDate(order?.create_ts) : ""}
                    </span>
                  </h5>
                </div>
              </li>
              <li className="col-12 col-md-6">
                <div className="order-detail-box">
                  <FiPackage className="detail-icon" />
                  <h5>
                    Fulfillment
                    <span>
                      {order?.order_type} <small>({order?.status_name})</small>
                    </span>
                  </h5>
                </div>
              </li>
              <li className="col-12 col-md-6">
                <div className="order-detail-box">
                  <FiMapPin className="detail-icon" />
                  <h5>
                    Address
                    <span>{order?.address}</span>
                  </h5>
                </div>
              </li>
            </ul>
          </div>
          <div className="table_order">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: "60%" }}>Products</th>
                  <th className="text-center">Quantity</th>
                  <th className="text-end">Price</th>
                </tr>
              </thead>
              <tbody>
                {order?.products.map((product: OrderProductModel, key: any) => (
                  <tr key={key}>
                    <td>
                      <OrderProduct product={product} />
                    </td>
                    <td className="text-center">x{product.product_qty}</td>
                    <td className="text-end">
                      {Number(product.product_discount) > 0 && (
                        <span className="text-danger cut-price text-decoration-line-through me-1">
                          {formatCurrency(Number(product.product_price))}
                        </span>
                      )}
                      <span>
                        {formatCurrency(
                          Number(product.product_price) -
                            Number(product.product_discount),
                        )}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="table_order_number">
            <div className="help-icon">
              <FiPhone size={26} />
            </div>

            <div className="help-text">
              <h5>Need help with your order?</h5>
              <p>Contact Restaurant</p>
            </div>

            <a href={`tel:${selectedStore?.store_phone}`}>
              <FiPhone size={22} className="mx-2" />
              {formatPhoneNumber(selectedStore?.store_phone)}
            </a>
          </div>
          <div className="choose_payment_subtotal common-card-border">
            <table>
              <tbody>
                {order?.total?.map((item) => (
                  <tr key={item.sort}>
                    <td>
                      <span
                        className={clsx(
                          "d-flex align-items-center gap-1",
                          item.name === "Total" && `order_price`,
                        )}
                      >
                        {item.name}{" "}
                        {item.id === "shipping" &&
                          order.is_third_party_delivery == "1" && (
                            <DoorDashIcon size={18} />
                          )}
                      </span>
                    </td>
                    <td>
                      <span
                        className={item.name === "Total" ? `order_price` : ""}
                      >
                        {formatCurrency(item.price)}
                      </span>
                    </td>
                  </tr>
                ))}

                {order?.payment_mode && (
                  <tr>
                    <td className={clsx("text-start fw-bold text-uppercase")}>
                      Payment Mode
                    </td>
                    <td className={clsx("text-end fw-bold text-uppercase")}>
                      {order.payment_mode.toUpperCase()}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="table_number_reorder">
            {!order?.is_favourite ? (
              <button className="favBtn" onClick={handleFavOrder}>
                <img src={toAbsoluteUrl("images/like-vector.svg")} alt="" />{" "}
                Save to Favorite
              </button>
            ) : (
              <button className="favBtn" onClick={handleFavOrder}>
                <HeartFill size={20} color="red" className="me-1" /> Remove from
                Favorites
              </button>
            )}
            <button className="reorderBtn" onClick={handleReorder}>
              REORDER
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <FavOrderModal
        show={showFavModal}
        handleClose={() => setShowFavModal(false)}
        handleSubmit={() => {}}
      />
    </>
  );
};

export default OrderDetailModal;
